import React from "react";
import List from "./TimeComponents/List";
import Shift from "./TimeComponents/Shift";
import Week from "./TimeComponents/Week";

const SetTimes = ({ form, setForm, inputs, getTemplate }) => {
  if (form.option.needdate) {
    if (form.show_model == "table") {
      return (
        <Week
          form={form}
          setForm={setForm}
          inputs={inputs}
          getTemplate={getTemplate}
        />
      );
    } else if (form.show_model == "list") {
      return <List form={form} setForm={setForm} inputs={inputs} />;
    }
  } else {
    return <Shift form={form} setForm={setForm} inputs={inputs} />;
  }
};
export default SetTimes;
